import useTranslation from 'next-translate/useTranslation';
import NextImage from 'next/image';
import router from 'next/router';
import { useMutation } from 'react-query';
import { Box, Flex } from 'rebass';
import styled from 'styled-components';

import CardOutlined from '@/components/CardOutlined';
import LoadingOverlay from '@/components/LoadingOverlay';
import Text from '@/components/Text';
import { toast } from '@/components/Toaster/Toaster';
import { userApi } from '@/services';
import TargetMap from '@/widgets/Auth/TargetMap';

const MyFlex = styled(Flex)`
  flex-basis: 48%;
  @media (max-width: 1200px) {
    flex-basis: 100%;
  }
`;

const Target = (status) => {
  const { t } = useTranslation('common-overview-mapping');
  const { t: h } = useTranslation('page-auth');
  const welcome = h('Welcome', {}, { returnObjects: true });
  const { t: m } = useTranslation('common-toast');
  const toaster = m('toast', {}, { returnObjects: true });

  const { mutateAsync: mutateTipp } = useMutation(
    'goals',
    async (val) => {
      const key = t(val, {}, { returnObjects: true });
      const tippfiltered = key.tipp.map((itemTipp) => {
        return itemTipp.Tipps;
      });
      const metricsfiltered = key.metrics.map((itemTipp) => {
        return itemTipp.metrics;
      });
      try {
        const { data } = await userApi.post(`/account/user-goals?goals=${val}`, {
          metrics: metricsfiltered,
          tipps: tippfiltered,
        });
        return data.data;
      } catch (e) {
        throw new Error(e.message);
      }
    },
    {
      onSuccess: async () => {
        await router.push('/dashboard');
        toast({
          type: 'success',
          message: toaster.profile.saved,
          dismissable: true,
          withIcon: true,
        });
      },
      onError: (err) => {
        toast({
          type: 'error',
          message: 'Fehler beim Speichern!',
          dismissable: true,
          withIcon: true,
          error: err,
        });
      },
    }
  );

  const handleClick = async (key) => {
    await mutateTipp(key);
  };

  return (
    <LoadingOverlay status={status} loadOnMount>
      <Text mb={['2.5rem', '2.5rem', '2.5rem']} variant="headlineGrey">
        {welcome.headline}
      </Text>
      <Text variant="capsTitle">{welcome.step}</Text>
      <Text variant="subtitlePrimary">{welcome.subheadline}</Text>
      <Text marginBottom={['1rem', '1rem', '1rem']} variant="bodyLightSmallNativ">
        {welcome.title}
      </Text>
      <Text color="primaryDisabled" mb={['3.125rem', '3.125rem', '3.125rem']} variant="bodyLightSmallNativ">
        {welcome.text}
      </Text>
      <Flex
        flexDirection={['row', 'row', 'row']}
        flexWrap="wrap"
        justifyContent={['space-between', 'space-between', 'space-between']}
      >
        {TargetMap().targets.map((item) => (
          <MyFlex flexDirection="column">
            <CardOutlined
              border="1"
              borderColor="#ebebeb"
              boxShadow="none"
              mb={['1.25rem', '1.25rem', '1.25rem']}
              mr={['1.5rem', '', '']}
              px={['0', '0', '0']}
              py={['0', '0', '0']}
              flexBasis="50%"
              sx={{ cursor: 'pointer' }}
              onClick={() => handleClick(item.key ?? null)}
            >
              <div
                style={{
                  borderTopLeftRadius: '10px',
                  borderTopRightRadius: '10px',
                  height: '100%',
                  overflow: 'hidden',
                  width: '100%',
                }}
              >
                <NextImage
                  alt={item.alternativeText}
                  height={60}
                  loading="lazy"
                  layout="responsive"
                  quality="75"
                  src={item.image}
                  width={159}
                />
              </div>
              <Box px={['15px', '30px', '30px']} width={['100%', '100%', '100%']} textAlign="center">
                <Text
                  lineHeight={['0.938rem', '0.938rem', '0.938rem']}
                  marginTop={['0.875rem', '0.875rem', '0.875rem']}
                  marginBottom={['1rem', '1rem', '1rem']}
                  variant="smallBoldEstate"
                  hyphens={['auto', 'auto', 'auto']}
                >
                  {item.title}
                </Text>
              </Box>
            </CardOutlined>
          </MyFlex>
        ))}
      </Flex>
    </LoadingOverlay>
  );
};

export default Target;
